import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountEmail = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.5249 12.2109H17.3349C16.4366 12.2109 15.6391 12.7059 15.2358 13.5126L14.4658 15.0343C14.2824 15.4009 13.9158 15.6301 13.5124 15.6301L10.5058 15.6301C10.2216 15.6301 9.81825 15.5659 9.55242 15.0343L8.78242 13.5218C8.37909 12.7243 7.57242 12.2201 6.68325 12.2201H3.47492C3.11742 12.2201 2.83325 12.5043 2.83325 12.8618L2.83325 15.8501C2.83325 19.1776 4.83159 21.1668 8.16825 21.1668H15.8499C18.9941 21.1668 20.9283 19.4434 21.1666 16.3818V12.8526C21.1666 12.5043 20.8824 12.2109 20.5249 12.2109Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21.1666 8.15908V10.9458C20.9649 10.8724 20.7449 10.8358 20.5249 10.8358H17.3349C15.9141 10.8358 14.6399 11.6241 14.0074 12.8891L13.3199 14.2458H10.6983L10.0108 12.8983C9.37825 11.6241 8.10408 10.8358 6.68325 10.8358H3.47492C3.25492 10.8358 3.03492 10.8724 2.83325 10.9458L2.83325 8.15908C2.83325 4.82242 4.82242 2.83325 8.15909 2.83325L15.8408 2.83325C19.1774 2.83325 21.1666 4.82242 21.1666 8.15908Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgAccountEmail);
export default ForwardRef;
